const deepFreeze = (obj) => {
    Object.getOwnPropertyNames(obj).forEach((prop) => {
        const value = obj[prop];
        if (value && typeof value === 'object' && !Object.isFrozen(value)) {
            deepFreeze(value);
        }
    });
    return Object.freeze(obj);
};
const config = deepFreeze({
    de: {
        production: 'sosafe.de',
        staging: 'sosafe-stage.de',
        development: 'sosafe-dev.de',
        test: 'sosafe-dev.de',
    },
    com: {
        production: 'sosafe-security.com', // TODO: change to sosafe.com when we have a new domain
        staging: 'sosafe-security.com', // TODO: change to sosafe-stage.com when we have a new domain
        development: 'sosafe-security.com', // TODO: change to sosafe-dev.com when we have a new domain
        test: 'sosafe-security.com', // TODO: change to sosafe-dev.com when we have a new domain
    },
});
/**
 * Returns the environment-specific domain for a given top-level domain (TLD).
 *
 * @param {'de' | 'com'} tld - The top-level domain to retrieve the config for.
 * @param {string} env - The environment to retrieve the config for.
 * @returns {string} The domain string corresponding to the current DEPLOY_ENVIRONMENT and given TLD.
 */
const getTLD = (tld, env) => config[tld][env || 'development'];
/**
 * A map of allowed top-level domains and their environment-specific base domains.
 */
const allowedTLDs = (env) => ({
    de: getTLD('de', env),
    com: getTLD('com', env),
});
/**
 * Extracts the top-level domain from a given URL and returns the corresponding
 * allowed domain if it's recognized and valid for the current environment.
 *
 * @param {string} url - The URL to parse and extract the domain from.
 * @param {string} env - The environment to retrieve the config for.
 * @returns {string} The allowed domain for the TLD, or 'sosafe.de' if invalid or not allowed.
 */
const getAppDomain = (url, env) => {
    try {
        const { hostname } = new URL(url);
        const parts = hostname.split('.');
        if (parts.length >= 2) {
            const tld = parts[parts.length - 1];
            return allowedTLDs(env)[tld] || allowedTLDs(env).de;
        }
        return allowedTLDs(env).de;
    }
    catch (e) {
        return allowedTLDs(env).de;
    }
};
/**
 * Replaces the domain in each URL within the provided object with a new domain.
 *
 * This function takes an object where each key is associated with a URL string.
 * It updates the domain of each URL to the specified new domain and returns a new object
 * with the same keys but with the URLs updated.
 *
 * @param urls - A record object where keys are strings and values are URL strings.
 * @param newDomain - The new domain to replace in each URL.
 * @returns A new record object with the same keys as the input, but with URLs updated to use the new domain.
 */
const replaceDomain = (urls, newDomain) => Object.fromEntries(Object.entries(urls).map(([key, url]) => {
    const { hostname, protocol, pathname, search, hash } = new URL(url);
    const parts = hostname.split('.');
    // Extract subdomain (everything before the last two segments)
    const subdomain = parts.slice(0, -2).join('.');
    // Build new hostname by combining subdomain with the new base domain
    const newHostname = subdomain ? `${subdomain}.${newDomain}` : newDomain;
    // Rebuild the full URL with the updated hostname
    const newUrl = `${protocol}//${newHostname}${pathname}${search}${hash}`;
    return [key, newUrl];
}));

export { deepFreeze, getAppDomain, replaceDomain };
//# sourceMappingURL=utils.js.map
